import {
    MarkovRedistributionStateFrom,
    MarkovRedistributionStateTo,
    MarkovState,
} from "server/models"
import { inferLiteral, OrderType } from "client/utils"
import { MarkovStateFilters } from "client/store"
import * as types from "./types"

// state from

export const setMarkovRedistributionStateFromList = (stateList: types.MarkovRedistributionStateFromList) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_LIST),
    stateList,
})
export const setMarkovRedistributionStateFromIds = (stateIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_IDS),
    stateIds,
})
export const setMarkovRedistributionStateFromEdit = (state: MarkovRedistributionStateFrom) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_EDIT),
    state,
})
export const setMarkovRedistributionStateFromCalculatedExpressions = (calcualted: types.MarkovRedistributionStateCalculated) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_CALCULATED_EXPRESSIONS),
    calcualted,
})
export const setMarkovRedistributionStateFromSort = (sortColumn: keyof MarkovState, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovRedistributionStateFromFilters = (filters: MarkovStateFilters) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_FILTERS),
    filters,
})
export const setMarkovRedistributionStateFromReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_LIST),
    value,
})
export const setMarkovRedistributionStateFromReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_EDIT),
    value,
})

// state to

export const setMarkovRedistributionStateToList = (stateList: types.MarkovRedistributionStateToList) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_LIST),
    stateList,
})
export const setMarkovRedistributionStateToIds = (stateIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_IDS),
    stateIds,
})
export const setMarkovRedistributionStateToEdit = (state: MarkovRedistributionStateTo) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_EDIT),
    state,
})
export const setMarkovRedistributionStateToCalculatedExpressions = (calcualted: types.MarkovRedistributionStateCalculated) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_CALCULATED_EXPRESSIONS),
    calcualted,
})
export const setMarkovRedistributionStateToSort = (sortColumn: keyof MarkovState, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovRedistributionStateToFilters = (filters: MarkovStateFilters) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_FILTERS),
    filters,
})
export const setMarkovRedistributionStateToReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_LIST),
    value,
})
export const setMarkovRedistributionStateToReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_EDIT),
    value,
})
